import styled from "styled-components";

export const TableWrapper = styled.div`
  width: 95%;
  overflow-x: auto;
  margin: 2rem auto;
  overflow-y: hidden;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch; /* smooth scroll on iOS */

  table {
    min-width: 650px; /* ensures columns don't collapse */
    overflow-x: auto;
  }
`;

export const Table = styled.table`

  width: 100%;
  border-collapse: collapse;
  text-align: center;
  direction: ltr;
  /* For mobile phones */
  @media (max-width: 768px) {
    direction: rtl;
  }
  `;

export const Th = styled.th`
  background-color: rgba(10, 92, 87, 0.94);
  color: white;
  padding: 12px;
  border: none;
  font-weight: bold;
  white-space: nowrap;
  
`;

export const Td = styled.td`
  padding: 10px;
  background-color: white;
  border-top: 1px solid #ccc;
  white-space: nowrap; /* prevent cell text from breaking */

  @media (max-width: 600px) {
    padding: 8px;
  }
`;

